import { observable } from "mobx";
import { entityToFormData } from "repositories/helpers";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export class ReqFile {
  @observable
  file!: Blob;

  static ValidationRules = {
    file: { required: true },
  };
}

export default class CustomReqFile extends ReqFile {
  toFormData() {
    const data = entityToFormData(this);

    // generic entityToFomData is creating "[object OBJECT]" string instead of file
    data.delete("file");
    if (this.file) {
      data.append("file", this.file);
    }

    return data;
  }
}
